import { FormEventHandler } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/Elements/Input';
import WarnList from '../../../components/Elements/WarnList';
import AuthCard from './AuthCard';

interface IForm {
    onSubmit: FormEventHandler<HTMLFormElement>;
    warns: any;
    loading: boolean;
}

export default function RegisterForm({ onSubmit, warns, loading }: IForm) {
    const navigate = useNavigate();

    return (
        <AuthCard titulo='Cadastro' subtitulo='Depois de criar, confirme pelo link que chega no seu e-mail.'>
            <form autoComplete='off' onSubmit={onSubmit}>
                <WarnList warns={warns}/>
                <Input id='name' label='Nome' />
                <Input id='email' label='E-mail' type='email' />
                <Input id='password' label='Senha' type='password' />
                <Input id='confirmPassword' label='Confirmar senha' type='password' />
                <button type='submit' disabled={loading} className='auth-botao'>Criar conta</button>
                <div className='auth-rodape auth-rodape--centro'>
                    <span>Já tem conta? <button type='button' className='auth-link' onClick={() => navigate('/auth/login')}>Entrar</button></span>
                </div>
            </form>
        </AuthCard>
    )
}
